import { DEFAULT_SUPPORA_ATTACHMENT_POLICY, sanitizeAttachmentPolicy, } from './attachments';
export const DEFAULT_SUPPORA_CONFIG = {
    channelId: '',
    apiBaseUrl: '',
    widgetUrl: '',
    primaryColor: '#0a84ff',
    onPrimaryColor: '#ffffff',
    backgroundColor: '#fbfbfd',
    textColor: '#17171a',
    mutedTextColor: '#6e6e73',
    borderColor: 'rgba(60, 60, 67, 0.18)',
    launcherPosition: 'bottom-right',
    showLauncherLabel: true,
    showLauncherIcon: true,
    launcherLabel: 'Support',
    title: 'Support',
    subtitle: 'We usually reply in a few minutes.',
    welcomeMessage: 'Welcome. Send us a message and we will help from here.',
    companyName: 'Suppora',
    borderRadius: 24,
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mode: 'system',
    requireEmail: false,
    collectName: false,
    requireName: false,
    identityMode: 'anonymous_or_unverified',
    privacyPolicyUrl: '',
    attachments: DEFAULT_SUPPORA_ATTACHMENT_POLICY,
    zIndex: 2147483000,
    initialOpen: false,
    debug: false,
};
export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function sanitizeMetadata(value) {
    if (!isRecord(value)) {
        return {};
    }
    return Object.fromEntries(Object.entries(value).filter((entry) => {
        const item = entry[1];
        return (typeof item === 'string' ||
            (typeof item === 'number' && Number.isFinite(item)) ||
            typeof item === 'boolean' ||
            item === null);
    }));
}
export function sanitizeIdentity(value) {
    if (!isRecord(value)) {
        return null;
    }
    const identity = {};
    assignString(identity, 'userId', value.userId);
    assignString(identity, 'email', value.email);
    assignString(identity, 'name', value.name);
    assignString(identity, 'avatarUrl', value.avatarUrl);
    assignString(identity, 'identityToken', value.identityToken);
    if (value.verificationStatus === 'anonymous' ||
        value.verificationStatus === 'unverified' ||
        value.verificationStatus === 'verified') {
        identity.verificationStatus = value.verificationStatus;
    }
    return identity;
}
export function sanitizeConfig(input) {
    if (!isRecord(input)) {
        return {};
    }
    const config = {};
    for (const [key, value] of Object.entries(input)) {
        switch (key) {
            case 'primaryColor':
            case 'onPrimaryColor':
            case 'backgroundColor':
            case 'textColor':
            case 'mutedTextColor':
            case 'borderColor':
            case 'channelId':
            case 'apiBaseUrl':
            case 'widgetUrl':
            case 'launcherLabel':
            case 'title':
            case 'subtitle':
            case 'welcomeMessage':
            case 'companyName':
            case 'fontFamily':
            case 'privacyPolicyUrl':
                if (typeof value === 'string') {
                    config[key] = value;
                }
                break;
            case 'attachments': {
                const attachments = sanitizeAttachmentPolicy(value);
                if (attachments) {
                    config.attachments = attachments;
                }
                break;
            }
            case 'launcherPosition':
                if (value === 'bottom-left' || value === 'bottom-right') {
                    config[key] = value;
                }
                break;
            case 'mode':
                if (value === 'light' || value === 'dark' || value === 'system') {
                    config[key] = value;
                }
                break;
            case 'identityMode':
                if (value === 'anonymous' ||
                    value === 'anonymous_or_unverified' ||
                    value === 'verified_only') {
                    config[key] = value;
                }
                break;
            case 'showLauncherLabel':
            case 'showLauncherIcon':
            case 'requireEmail':
            case 'collectName':
            case 'requireName':
            case 'initialOpen':
            case 'debug':
                if (typeof value === 'boolean') {
                    config[key] = value;
                }
                break;
            case 'borderRadius':
                if (typeof value === 'number' && Number.isFinite(value)) {
                    config[key] = clamp(value, 10, 34);
                }
                break;
            case 'zIndex':
                if (typeof value === 'number' && Number.isFinite(value)) {
                    config[key] = Math.round(clamp(value, 1, 2147483647));
                }
                break;
        }
    }
    return config;
}
export function normalizeConfig(input, fallback = DEFAULT_SUPPORA_CONFIG) {
    return {
        ...fallback,
        ...sanitizeConfig(input),
    };
}
function assignString(target, key, value) {
    if (typeof value === 'string' && value.length > 0) {
        target[key] = value;
    }
}
function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
//# sourceMappingURL=config.js.map